var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _circle493, _circle494, _circle495, _circle496, _circle497, _circle498, _circle499, _circle500, _circle501, _circle502, _circle503, _circle504, _circle505, _circle506, _circle507, _circle508, _circle509, _circle510, _circle511, _circle512, _circle513, _circle514, _circle515, _circle516, _circle517, _circle518, _circle519, _circle520, _circle521, _circle522, _circle523, _circle524, _circle525, _circle526, _circle527, _circle528, _circle529, _circle530, _circle531, _circle532, _circle533, _circle534, _circle535, _circle536, _circle537, _circle538, _circle539, _circle540, _circle541, _circle542, _circle543, _circle544, _circle545, _circle546, _circle547, _circle548, _circle549, _circle550, _circle551, _circle552, _circle553, _circle554, _circle555, _circle556, _circle557, _circle558, _circle559, _circle560, _circle561, _circle562, _circle563, _circle564, _circle565, _circle566, _circle567, _circle568, _circle569, _circle570, _circle571, _circle572, _circle573, _circle574, _circle575, _circle576, _circle577, _circle578, _circle579, _circle580, _circle581, _circle582, _circle583, _circle584, _circle585, _circle586, _circle587, _circle588, _circle589, _circle590, _circle591, _circle592, _circle593, _circle594, _circle595, _circle596, _circle597, _circle598, _circle599, _circle600, _circle601, _circle602, _circle603, _circle604, _circle605, _circle606, _circle607, _circle608, _circle609, _circle610, _circle611, _circle612, _circle613, _circle614, _circle615, _circle616, _circle617, _circle618, _circle619, _circle620, _circle621, _circle622, _circle623, _circle624, _circle625, _circle626, _circle627, _circle628, _circle629, _circle630, _circle631, _circle632, _circle633, _circle634, _circle635, _circle636, _circle637, _circle638, _circle639, _circle640, _circle641, _circle642, _circle643, _circle644, _circle645, _circle646, _circle647, _circle648, _circle649, _circle650, _circle651, _circle652, _circle653, _circle654, _circle655, _circle656, _circle657, _circle658, _circle659, _circle660, _circle661, _circle662, _circle663, _circle664, _circle665, _circle666, _circle667, _circle668, _circle669, _circle670, _circle671, _circle672, _circle673, _circle674, _circle675, _circle676, _circle677, _circle678, _circle679, _circle680, _circle681, _circle682, _circle683, _circle684, _circle685, _circle686, _circle687, _circle688, _circle689, _circle690, _circle691, _circle692, _circle693, _circle694, _circle695, _circle696, _circle697, _circle698, _circle699, _circle700, _circle701, _circle702, _circle703, _circle704, _circle705, _circle706, _circle707, _circle708, _circle709, _circle710, _circle711, _circle712, _circle713, _circle714, _circle715, _circle716, _circle717, _circle718, _circle719, _circle720, _circle721, _circle722, _circle723, _circle724, _circle725, _circle726, _circle727, _circle728, _circle729, _circle730, _circle731, _circle732, _circle733, _circle734, _circle735, _circle736, _circle737, _circle738, _circle739, _circle740, _circle741, _circle742, _circle743, _circle744, _circle745, _circle746, _circle747, _circle748, _circle749, _circle750, _circle751, _circle752, _circle753, _circle754, _circle755, _circle756, _circle757, _circle758, _circle759, _circle760, _circle761, _circle762, _circle763, _circle764, _circle765, _circle766, _circle767, _circle768, _circle769, _circle770, _circle771, _circle772, _circle773, _circle774, _circle775, _circle776, _circle777, _circle778, _circle779, _circle780, _circle781, _circle782, _circle783, _circle784, _circle785, _circle786, _circle787, _circle788, _circle789, _circle790, _circle791, _circle792, _circle793, _circle794, _circle795, _circle796, _circle797, _circle798, _circle799, _circle800, _circle801, _circle802, _circle803, _circle804, _circle805, _circle806, _circle807, _circle808, _circle809, _circle810, _circle811, _circle812, _circle813, _circle814, _circle815, _circle816, _circle817, _circle818, _circle819, _circle820, _circle821, _circle822, _circle823, _circle824, _circle825, _circle826, _circle827, _circle828, _circle829, _circle830, _circle831, _circle832, _circle833, _circle834, _circle835, _circle836, _circle837, _circle838, _circle839, _circle840, _circle841, _circle842, _circle843, _circle844, _circle845, _circle846, _circle847, _circle848, _circle849, _circle850, _circle851, _circle852, _circle853, _circle854, _circle855, _circle856, _circle857, _circle858, _circle859, _circle860, _circle861, _circle862, _circle863, _circle864, _circle865, _circle866, _circle867, _circle868, _circle869, _circle870, _circle871, _circle872, _circle873, _circle874, _circle875, _circle876, _circle877, _circle878, _circle879, _circle880, _circle881, _circle882, _circle883, _circle884, _circle885, _circle886, _circle887, _circle888, _circle889, _circle890, _circle891, _circle892, _circle893, _circle894, _circle895, _circle896, _circle897, _circle898, _circle899, _circle900, _circle901, _circle902, _circle903, _circle904, _circle905, _circle906, _circle907, _circle908, _circle909, _circle910, _circle911, _circle912, _circle913, _circle914, _circle915, _circle916, _circle917, _circle918, _circle919, _circle920, _circle921, _circle922, _circle923, _circle924, _circle925, _circle926, _circle927, _circle928, _circle929, _circle930, _circle931, _circle932, _circle933, _circle934, _circle935, _circle936, _circle937, _circle938, _circle939, _circle940, _circle941, _circle942, _circle943, _circle944, _circle945, _circle946, _circle947, _circle948, _circle949, _circle950, _circle951, _circle952, _circle953, _circle954, _circle955, _circle956, _circle957, _circle958, _circle959, _circle960, _circle961, _circle962, _circle963, _circle964, _circle965, _circle966, _circle967, _circle968, _circle969, _circle970, _circle971, _circle972, _circle973, _circle974, _circle975, _circle976, _circle977, _circle978, _circle979, _circle980, _circle981, _circle982, _circle983, _circle984, _circle985, _circle986, _circle987, _circle988, _circle989, _circle990, _circle991, _circle992, _circle993, _circle994, _circle995, _circle996, _circle997, _circle998, _circle999, _circle1000, _circle1001, _circle1002, _circle1003, _circle1004, _circle1005, _circle1006, _circle1007, _circle1008, _circle1009, _circle1010, _circle1011, _circle1012, _circle1013, _circle1014, _circle1015, _circle1016, _circle1017, _circle1018, _circle1019, _circle1020, _circle1021, _circle1022, _circle1023, _circle1024, _circle1025, _circle1026, _circle1027, _circle1028, _circle1029, _circle1030, _circle1031, _circle1032, _circle1033, _circle1034, _circle1035, _circle1036, _circle1037, _circle1038, _circle1039, _circle1040, _circle1041, _circle1042, _circle1043, _circle1044, _circle1045, _circle1046, _circle1047, _circle1048, _circle1049, _circle1050, _circle1051, _circle1052, _circle1053, _circle1054, _circle1055, _circle1056, _circle1057, _circle1058, _circle1059, _circle1060, _circle1061, _circle1062, _circle1063, _circle1064, _circle1065, _circle1066, _circle1067, _circle1068, _circle1069, _circle1070, _circle1071, _circle1072, _circle1073, _circle1074, _circle1075, _circle1076, _circle1077, _circle1078, _circle1079, _circle1080, _circle1081, _circle1082, _circle1083, _circle1084, _circle1085, _circle1086, _circle1087, _circle1088, _circle1089, _circle1090, _circle1091, _circle1092, _circle1093, _circle1094, _circle1095, _circle1096, _circle1097, _circle1098, _circle1099, _circle1100, _circle1101, _circle1102, _circle1103, _circle1104, _circle1105, _circle1106, _circle1107, _circle1108, _circle1109, _circle1110, _circle1111, _circle1112, _circle1113, _circle1114, _circle1115, _circle1116, _circle1117, _circle1118, _circle1119, _circle1120, _circle1121, _circle1122, _circle1123, _circle1124, _circle1125, _circle1126, _circle1127, _circle1128, _circle1129, _circle1130, _circle1131, _circle1132, _circle1133, _circle1134, _circle1135, _circle1136, _circle1137, _circle1138, _circle1139, _circle1140, _circle1141, _circle1142, _circle1143, _circle1144, _circle1145, _circle1146, _circle1147, _circle1148, _circle1149, _circle1150, _circle1151, _circle1152, _circle1153, _circle1154, _circle1155, _circle1156, _circle1157, _circle1158, _circle1159, _circle1160, _circle1161, _circle1162, _circle1163, _circle1164, _circle1165, _circle1166, _circle1167, _circle1168, _circle1169, _circle1170, _circle1171, _circle1172, _circle1173, _circle1174, _circle1175, _circle1176, _circle1177, _circle1178, _circle1179, _circle1180, _circle1181, _circle1182, _circle1183, _circle1184, _circle1185, _circle1186, _circle1187, _circle1188, _circle1189, _circle1190, _circle1191, _circle1192, _circle1193, _circle1194, _circle1195, _circle1196, _circle1197, _circle1198, _circle1199, _g, _circle1200, _circle1201, _circle1202, _circle1203, _circle1204, _circle1205, _circle1206, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroSmall = function SvgHeroSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 389,
    height: 226,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hero-small_svg__b",
    width: 606,
    height: 226,
    x: -108,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero-small_svg__a)",
    d: "M-108 .39h606V225.8h-606z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hero-small_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__c)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 83.657,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 83.657,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__d)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 92.068,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 92.068,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__e)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 100.479,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 100.479,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__f)"
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 108.89,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 108.89,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__g)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 117.301,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 117.301,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__h)"
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 125.711,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 125.711,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__i)"
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 134.122,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 134.122,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__j)"
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 142.533,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -2.865,
    cy: 142.533,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__k)"
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 83.657,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 83.657,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__l)"
  }, _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 142.533,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 142.533,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__m)"
  }, _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 150.944,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 150.944,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__n)"
  }, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 167.766,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 167.766,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__o)"
  }, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 176.177,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 176.177,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__p)"
  }, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 184.587,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 184.587,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__q)"
  }, _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 192.998,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 192.998,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__r)"
  }, _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__s)"
  }, _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 66.836,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 66.836,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__t)"
  }, _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__u)"
  }, _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 83.657,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 83.657,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__v)"
  }, _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.957,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__w)"
  }, _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 50.014,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 50.014,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__x)"
  }, _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 58.425,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 58.425,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__y)"
  }, _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 66.836,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 66.836,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__z)"
  }, _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.368,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__A)"
  }, _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 41.603,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 41.603,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__B)"
  }, _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 50.014,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 50.014,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__C)"
  }, _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.779,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__D)"
  }, _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.19,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__E)"
  }, _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__F)"
  }, _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.011,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__G)"
  }, _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 201.409,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 201.409,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.422,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.833,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.244,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.655,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.065,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.476,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.887,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.298,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.709,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.12,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.53,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.941,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.352,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__H)"
  }, _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 24.782,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 24.782,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.763,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__I)"
  }, _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 33.192,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 33.192,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__J)"
  }, _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 41.603,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 41.603,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.174,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__K)"
  }, _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 50.014,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 50.014,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__L)"
  }, _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 58.425,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 58.425,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle603 || (_circle603 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.584,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle604 || (_circle604 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle605 || (_circle605 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle606 || (_circle606 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle607 || (_circle607 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle608 || (_circle608 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle609 || (_circle609 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__M)"
  }, _circle610 || (_circle610 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 66.836,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 66.836,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__N)"
  }, _circle611 || (_circle611 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle612 || (_circle612 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle613 || (_circle613 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle614 || (_circle614 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle615 || (_circle615 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle616 || (_circle616 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle617 || (_circle617 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle618 || (_circle618 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle619 || (_circle619 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle620 || (_circle620 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle621 || (_circle621 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle622 || (_circle622 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle623 || (_circle623 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle624 || (_circle624 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle625 || (_circle625 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle626 || (_circle626 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle627 || (_circle627 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle628 || (_circle628 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle629 || (_circle629 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle630 || (_circle630 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle631 || (_circle631 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle632 || (_circle632 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle633 || (_circle633 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle634 || (_circle634 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle635 || (_circle635 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle636 || (_circle636 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__O)"
  }, _circle637 || (_circle637 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle638 || (_circle638 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle639 || (_circle639 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle640 || (_circle640 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle641 || (_circle641 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle642 || (_circle642 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle643 || (_circle643 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle644 || (_circle644 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle645 || (_circle645 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle646 || (_circle646 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle647 || (_circle647 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle648 || (_circle648 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle649 || (_circle649 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle650 || (_circle650 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle651 || (_circle651 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle652 || (_circle652 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle653 || (_circle653 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle654 || (_circle654 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.406,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle655 || (_circle655 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle656 || (_circle656 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle657 || (_circle657 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle658 || (_circle658 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle659 || (_circle659 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle660 || (_circle660 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle661 || (_circle661 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle662 || (_circle662 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__P)"
  }, _circle663 || (_circle663 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle664 || (_circle664 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle665 || (_circle665 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle666 || (_circle666 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle667 || (_circle667 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle668 || (_circle668 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle669 || (_circle669 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle670 || (_circle670 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle671 || (_circle671 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle672 || (_circle672 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle673 || (_circle673 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle674 || (_circle674 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle675 || (_circle675 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle676 || (_circle676 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle677 || (_circle677 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle678 || (_circle678 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle679 || (_circle679 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle680 || (_circle680 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.817,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle681 || (_circle681 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle682 || (_circle682 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle683 || (_circle683 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle684 || (_circle684 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle685 || (_circle685 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle686 || (_circle686 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle687 || (_circle687 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle688 || (_circle688 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__Q)",
    opacity: 0.6
  }, _circle689 || (_circle689 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle690 || (_circle690 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle691 || (_circle691 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle692 || (_circle692 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle693 || (_circle693 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle694 || (_circle694 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle695 || (_circle695 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle696 || (_circle696 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle697 || (_circle697 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle698 || (_circle698 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle699 || (_circle699 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle700 || (_circle700 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle701 || (_circle701 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle702 || (_circle702 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle703 || (_circle703 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle704 || (_circle704 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle705 || (_circle705 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle706 || (_circle706 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.228,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle707 || (_circle707 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle708 || (_circle708 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle709 || (_circle709 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle710 || (_circle710 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle711 || (_circle711 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle712 || (_circle712 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle713 || (_circle713 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle714 || (_circle714 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__R)",
    opacity: 0.8
  }, _circle715 || (_circle715 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle716 || (_circle716 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle717 || (_circle717 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle718 || (_circle718 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle719 || (_circle719 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle720 || (_circle720 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle721 || (_circle721 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle722 || (_circle722 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle723 || (_circle723 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle724 || (_circle724 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle725 || (_circle725 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle726 || (_circle726 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle727 || (_circle727 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle728 || (_circle728 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle729 || (_circle729 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle730 || (_circle730 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle731 || (_circle731 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle732 || (_circle732 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.638,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle733 || (_circle733 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle734 || (_circle734 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle735 || (_circle735 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle736 || (_circle736 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle737 || (_circle737 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle738 || (_circle738 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle739 || (_circle739 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle740 || (_circle740 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle741 || (_circle741 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle742 || (_circle742 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle743 || (_circle743 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle744 || (_circle744 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle745 || (_circle745 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle746 || (_circle746 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle747 || (_circle747 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle748 || (_circle748 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle749 || (_circle749 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle750 || (_circle750 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle751 || (_circle751 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle752 || (_circle752 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle753 || (_circle753 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle754 || (_circle754 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle755 || (_circle755 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle756 || (_circle756 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle757 || (_circle757 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle758 || (_circle758 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.049,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle759 || (_circle759 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle760 || (_circle760 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle761 || (_circle761 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle762 || (_circle762 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle763 || (_circle763 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle764 || (_circle764 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle765 || (_circle765 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle766 || (_circle766 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle767 || (_circle767 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle768 || (_circle768 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle769 || (_circle769 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle770 || (_circle770 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle771 || (_circle771 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle772 || (_circle772 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle773 || (_circle773 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle774 || (_circle774 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle775 || (_circle775 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle776 || (_circle776 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle777 || (_circle777 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle778 || (_circle778 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle779 || (_circle779 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle780 || (_circle780 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle781 || (_circle781 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle782 || (_circle782 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle783 || (_circle783 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle784 || (_circle784 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.46,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle785 || (_circle785 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle786 || (_circle786 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle787 || (_circle787 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle788 || (_circle788 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle789 || (_circle789 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle790 || (_circle790 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle791 || (_circle791 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle792 || (_circle792 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle793 || (_circle793 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle794 || (_circle794 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle795 || (_circle795 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle796 || (_circle796 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle797 || (_circle797 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle798 || (_circle798 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle799 || (_circle799 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle800 || (_circle800 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle801 || (_circle801 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle802 || (_circle802 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle803 || (_circle803 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle804 || (_circle804 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle805 || (_circle805 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle806 || (_circle806 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle807 || (_circle807 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle808 || (_circle808 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle809 || (_circle809 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle810 || (_circle810 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.871,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle811 || (_circle811 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle812 || (_circle812 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle813 || (_circle813 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle814 || (_circle814 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle815 || (_circle815 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle816 || (_circle816 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle817 || (_circle817 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle818 || (_circle818 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle819 || (_circle819 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle820 || (_circle820 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle821 || (_circle821 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle822 || (_circle822 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle823 || (_circle823 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle824 || (_circle824 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle825 || (_circle825 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle826 || (_circle826 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle827 || (_circle827 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle828 || (_circle828 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle829 || (_circle829 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle830 || (_circle830 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle831 || (_circle831 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle832 || (_circle832 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle833 || (_circle833 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle834 || (_circle834 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle835 || (_circle835 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle836 || (_circle836 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.282,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle837 || (_circle837 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle838 || (_circle838 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle839 || (_circle839 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle840 || (_circle840 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle841 || (_circle841 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle842 || (_circle842 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle843 || (_circle843 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle844 || (_circle844 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle845 || (_circle845 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle846 || (_circle846 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle847 || (_circle847 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle848 || (_circle848 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle849 || (_circle849 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle850 || (_circle850 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle851 || (_circle851 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle852 || (_circle852 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle853 || (_circle853 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle854 || (_circle854 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 150.944,
    r: 0.841,
    fill: "#3A6352"
  })), _circle855 || (_circle855 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 159.355,
    r: 0.841,
    fill: "#3A6352"
  })), _circle856 || (_circle856 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 167.766,
    r: 0.841,
    fill: "#3A6352"
  })), _circle857 || (_circle857 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 176.177,
    r: 0.841,
    fill: "#3A6352"
  })), _circle858 || (_circle858 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 184.587,
    r: 0.841,
    fill: "#3A6352"
  })), _circle859 || (_circle859 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 192.998,
    r: 0.841,
    fill: "#3A6352"
  })), _circle860 || (_circle860 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 201.409,
    r: 0.841,
    fill: "#3A6352"
  })), _circle861 || (_circle861 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 209.82,
    r: 0.841,
    fill: "#3A6352"
  })), _circle862 || (_circle862 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.693,
    cy: 218.231,
    r: 0.841,
    fill: "#3A6352"
  })), _circle863 || (_circle863 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle864 || (_circle864 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle865 || (_circle865 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle866 || (_circle866 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle867 || (_circle867 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle868 || (_circle868 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle869 || (_circle869 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle870 || (_circle870 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle871 || (_circle871 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle872 || (_circle872 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle873 || (_circle873 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle874 || (_circle874 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle875 || (_circle875 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle876 || (_circle876 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle877 || (_circle877 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle878 || (_circle878 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle879 || (_circle879 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle880 || (_circle880 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle881 || (_circle881 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle882 || (_circle882 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle883 || (_circle883 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle884 || (_circle884 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle885 || (_circle885 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle886 || (_circle886 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle887 || (_circle887 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle888 || (_circle888 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.103,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle889 || (_circle889 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle890 || (_circle890 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle891 || (_circle891 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle892 || (_circle892 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle893 || (_circle893 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle894 || (_circle894 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle895 || (_circle895 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle896 || (_circle896 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle897 || (_circle897 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle898 || (_circle898 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle899 || (_circle899 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle900 || (_circle900 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle901 || (_circle901 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle902 || (_circle902 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle903 || (_circle903 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle904 || (_circle904 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle905 || (_circle905 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle906 || (_circle906 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle907 || (_circle907 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle908 || (_circle908 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle909 || (_circle909 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle910 || (_circle910 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle911 || (_circle911 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle912 || (_circle912 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle913 || (_circle913 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle914 || (_circle914 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.514,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle915 || (_circle915 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle916 || (_circle916 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle917 || (_circle917 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle918 || (_circle918 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle919 || (_circle919 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle920 || (_circle920 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle921 || (_circle921 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle922 || (_circle922 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle923 || (_circle923 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle924 || (_circle924 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle925 || (_circle925 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle926 || (_circle926 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle927 || (_circle927 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle928 || (_circle928 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle929 || (_circle929 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle930 || (_circle930 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle931 || (_circle931 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle932 || (_circle932 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle933 || (_circle933 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle934 || (_circle934 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle935 || (_circle935 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle936 || (_circle936 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle937 || (_circle937 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle938 || (_circle938 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle939 || (_circle939 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle940 || (_circle940 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.925,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle941 || (_circle941 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle942 || (_circle942 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle943 || (_circle943 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle944 || (_circle944 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle945 || (_circle945 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle946 || (_circle946 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle947 || (_circle947 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle948 || (_circle948 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle949 || (_circle949 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle950 || (_circle950 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle951 || (_circle951 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle952 || (_circle952 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle953 || (_circle953 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle954 || (_circle954 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle955 || (_circle955 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle956 || (_circle956 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle957 || (_circle957 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle958 || (_circle958 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle959 || (_circle959 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle960 || (_circle960 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle961 || (_circle961 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle962 || (_circle962 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle963 || (_circle963 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle964 || (_circle964 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle965 || (_circle965 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle966 || (_circle966 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.336,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle967 || (_circle967 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle968 || (_circle968 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle969 || (_circle969 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle970 || (_circle970 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle971 || (_circle971 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle972 || (_circle972 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle973 || (_circle973 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle974 || (_circle974 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle975 || (_circle975 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle976 || (_circle976 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle977 || (_circle977 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle978 || (_circle978 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle979 || (_circle979 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle980 || (_circle980 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle981 || (_circle981 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle982 || (_circle982 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle983 || (_circle983 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle984 || (_circle984 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle985 || (_circle985 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle986 || (_circle986 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle987 || (_circle987 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle988 || (_circle988 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle989 || (_circle989 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle990 || (_circle990 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle991 || (_circle991 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle992 || (_circle992 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.747,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle993 || (_circle993 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle994 || (_circle994 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle995 || (_circle995 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle996 || (_circle996 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle997 || (_circle997 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle998 || (_circle998 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle999 || (_circle999 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1000 || (_circle1000 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1001 || (_circle1001 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1002 || (_circle1002 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1003 || (_circle1003 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1004 || (_circle1004 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1005 || (_circle1005 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1006 || (_circle1006 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1007 || (_circle1007 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1008 || (_circle1008 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1009 || (_circle1009 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1010 || (_circle1010 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1011 || (_circle1011 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1012 || (_circle1012 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1013 || (_circle1013 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1014 || (_circle1014 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1015 || (_circle1015 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1016 || (_circle1016 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1017 || (_circle1017 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1018 || (_circle1018 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.158,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1019 || (_circle1019 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1020 || (_circle1020 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1021 || (_circle1021 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle1022 || (_circle1022 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle1023 || (_circle1023 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1024 || (_circle1024 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1025 || (_circle1025 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1026 || (_circle1026 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1027 || (_circle1027 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1028 || (_circle1028 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1029 || (_circle1029 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1030 || (_circle1030 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1031 || (_circle1031 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1032 || (_circle1032 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1033 || (_circle1033 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1034 || (_circle1034 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1035 || (_circle1035 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1036 || (_circle1036 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1037 || (_circle1037 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1038 || (_circle1038 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1039 || (_circle1039 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1040 || (_circle1040 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1041 || (_circle1041 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1042 || (_circle1042 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1043 || (_circle1043 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1044 || (_circle1044 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.568,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1045 || (_circle1045 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1046 || (_circle1046 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__S)"
  }, _circle1047 || (_circle1047 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 24.782,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 24.782,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1048 || (_circle1048 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle1049 || (_circle1049 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1050 || (_circle1050 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1051 || (_circle1051 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1052 || (_circle1052 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1053 || (_circle1053 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1054 || (_circle1054 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1055 || (_circle1055 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1056 || (_circle1056 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1057 || (_circle1057 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1058 || (_circle1058 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1059 || (_circle1059 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1060 || (_circle1060 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1061 || (_circle1061 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1062 || (_circle1062 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1063 || (_circle1063 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1064 || (_circle1064 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1065 || (_circle1065 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1066 || (_circle1066 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1067 || (_circle1067 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1068 || (_circle1068 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1069 || (_circle1069 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1070 || (_circle1070 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.979,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1071 || (_circle1071 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1072 || (_circle1072 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__T)"
  }, _circle1073 || (_circle1073 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 24.782,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 24.782,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__U)"
  }, _circle1074 || (_circle1074 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 33.192,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 33.192,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1075 || (_circle1075 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1076 || (_circle1076 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1077 || (_circle1077 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1078 || (_circle1078 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1079 || (_circle1079 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1080 || (_circle1080 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1081 || (_circle1081 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1082 || (_circle1082 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1083 || (_circle1083 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1084 || (_circle1084 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1085 || (_circle1085 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1086 || (_circle1086 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1087 || (_circle1087 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1088 || (_circle1088 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1089 || (_circle1089 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1090 || (_circle1090 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1091 || (_circle1091 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1092 || (_circle1092 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1093 || (_circle1093 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1094 || (_circle1094 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1095 || (_circle1095 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1096 || (_circle1096 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.39,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1097 || (_circle1097 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1098 || (_circle1098 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1099 || (_circle1099 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__V)"
  }, _circle1100 || (_circle1100 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 33.192,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 33.192,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1101 || (_circle1101 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1102 || (_circle1102 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1103 || (_circle1103 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1104 || (_circle1104 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1105 || (_circle1105 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1106 || (_circle1106 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1107 || (_circle1107 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1108 || (_circle1108 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1109 || (_circle1109 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1110 || (_circle1110 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1111 || (_circle1111 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1112 || (_circle1112 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1113 || (_circle1113 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1114 || (_circle1114 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1115 || (_circle1115 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1116 || (_circle1116 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1117 || (_circle1117 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1118 || (_circle1118 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1119 || (_circle1119 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1120 || (_circle1120 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1121 || (_circle1121 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1122 || (_circle1122 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.801,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1123 || (_circle1123 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1124 || (_circle1124 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1125 || (_circle1125 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__W)"
  }, _circle1126 || (_circle1126 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 33.192,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 33.192,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1127 || (_circle1127 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1128 || (_circle1128 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1129 || (_circle1129 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1130 || (_circle1130 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1131 || (_circle1131 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1132 || (_circle1132 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), _circle1133 || (_circle1133 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 92.068,
    r: 0.841,
    fill: "#262626"
  })), _circle1134 || (_circle1134 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1135 || (_circle1135 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1136 || (_circle1136 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1137 || (_circle1137 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1138 || (_circle1138 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1139 || (_circle1139 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1140 || (_circle1140 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1141 || (_circle1141 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1142 || (_circle1142 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1143 || (_circle1143 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1144 || (_circle1144 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1145 || (_circle1145 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1146 || (_circle1146 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1147 || (_circle1147 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1148 || (_circle1148 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.212,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1149 || (_circle1149 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1150 || (_circle1150 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1151 || (_circle1151 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__X)"
  }, _circle1152 || (_circle1152 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 33.192,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 33.192,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__Y)"
  }, _circle1153 || (_circle1153 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 41.603,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 41.603,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__Z)"
  }, _circle1154 || (_circle1154 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 50.014,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 50.014,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__aa)"
  }, _circle1155 || (_circle1155 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 75.246,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 75.246,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ab)"
  }, _circle1156 || (_circle1156 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 83.657,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 83.657,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ac)"
  }, _circle1157 || (_circle1157 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 92.068,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 92.068,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1158 || (_circle1158 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1159 || (_circle1159 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1160 || (_circle1160 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1161 || (_circle1161 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1162 || (_circle1162 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1163 || (_circle1163 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1164 || (_circle1164 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1165 || (_circle1165 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1166 || (_circle1166 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1167 || (_circle1167 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1168 || (_circle1168 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1169 || (_circle1169 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1170 || (_circle1170 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1171 || (_circle1171 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1172 || (_circle1172 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), _circle1173 || (_circle1173 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 7.96,
    r: 0.841,
    fill: "#262626"
  })), _circle1174 || (_circle1174 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 16.371,
    r: 0.841,
    fill: "#262626"
  })), _circle1175 || (_circle1175 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 24.782,
    r: 0.841,
    fill: "#262626"
  })), _circle1176 || (_circle1176 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 33.192,
    r: 0.841,
    fill: "#262626"
  })), _circle1177 || (_circle1177 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 41.603,
    r: 0.841,
    fill: "#262626"
  })), _circle1178 || (_circle1178 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 50.014,
    r: 0.841,
    fill: "#262626"
  })), _circle1179 || (_circle1179 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 58.425,
    r: 0.841,
    fill: "#262626"
  })), _circle1180 || (_circle1180 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 66.836,
    r: 0.841,
    fill: "#262626"
  })), _circle1181 || (_circle1181 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 75.246,
    r: 0.841,
    fill: "#262626"
  })), _circle1182 || (_circle1182 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 83.657,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ad)"
  }, _circle1183 || (_circle1183 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 92.068,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 92.068,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1184 || (_circle1184 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 100.479,
    r: 0.841,
    fill: "#262626"
  })), _circle1185 || (_circle1185 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 108.89,
    r: 0.841,
    fill: "#262626"
  })), _circle1186 || (_circle1186 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 117.301,
    r: 0.841,
    fill: "#262626"
  })), _circle1187 || (_circle1187 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 125.711,
    r: 0.841,
    fill: "#262626"
  })), _circle1188 || (_circle1188 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 134.122,
    r: 0.841,
    fill: "#262626"
  })), _circle1189 || (_circle1189 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 142.533,
    r: 0.841,
    fill: "#262626"
  })), _circle1190 || (_circle1190 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 150.944,
    r: 0.841,
    fill: "#262626"
  })), _circle1191 || (_circle1191 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 159.355,
    r: 0.841,
    fill: "#262626"
  })), _circle1192 || (_circle1192 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 167.766,
    r: 0.841,
    fill: "#262626"
  })), _circle1193 || (_circle1193 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 176.177,
    r: 0.841,
    fill: "#262626"
  })), _circle1194 || (_circle1194 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 184.587,
    r: 0.841,
    fill: "#262626"
  })), _circle1195 || (_circle1195 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 192.998,
    r: 0.841,
    fill: "#262626"
  })), _circle1196 || (_circle1196 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 201.409,
    r: 0.841,
    fill: "#262626"
  })), _circle1197 || (_circle1197 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 209.82,
    r: 0.841,
    fill: "#262626"
  })), _circle1198 || (_circle1198 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.033,
    cy: 218.231,
    r: 0.841,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ae)"
  }, _circle1199 || (_circle1199 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.444,
    cy: 92.068,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 392.444,
    cy: 92.068,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero-small_svg__ag)",
    d: "M-160.147.39h710.294V225.8h-710.294z"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ah)",
    opacity: 0.7
  }, _circle1200 || (_circle1200 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 66.836,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 66.836,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ai)",
    opacity: 0.3
  }, _circle1201 || (_circle1201 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 159.355,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 159.355,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__aj)",
    opacity: 0.5
  }, _circle1202 || (_circle1202 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 58.425,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 58.425,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__ak)",
    opacity: 0.05
  }, _circle1203 || (_circle1203 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.865,
    cy: 192.998,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 392.865,
    cy: 192.998,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__al)",
    opacity: 0.1
  }, _circle1204 || (_circle1204 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.454,
    cy: 192.998,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 384.454,
    cy: 192.998,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__am)",
    opacity: 0.15
  }, _circle1205 || (_circle1205 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 192.998,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 192.998,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero-small_svg__an)",
    opacity: 0.6
  }, _circle1206 || (_circle1206 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 58.425,
    r: 0.841,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 198.995,
    cy: 58.425,
    r: 0.631,
    stroke: "#fff",
    strokeWidth: 0.421,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__c",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 76.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__d",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 84.666,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__e",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 93.078,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__f",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 101.488,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__g",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 109.899,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__h",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 118.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__i",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 126.721,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__j",
    width: 14.803,
    height: 14.803,
    x: -10.266,
    y: 135.132,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__k",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 76.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__l",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 135.132,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__m",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 143.542,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__n",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 160.364,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__o",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 168.775,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__p",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 177.186,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__q",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 185.597,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__r",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__s",
    width: 14.803,
    height: 14.803,
    x: 6.556,
    y: 59.434,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__t",
    width: 14.803,
    height: 14.803,
    x: 6.556,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__u",
    width: 14.803,
    height: 14.803,
    x: 6.556,
    y: 76.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__v",
    width: 14.803,
    height: 14.803,
    x: 6.556,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__w",
    width: 14.803,
    height: 14.803,
    x: 14.966,
    y: 42.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__x",
    width: 14.803,
    height: 14.803,
    x: 14.966,
    y: 51.023,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__y",
    width: 14.803,
    height: 14.803,
    x: 14.966,
    y: 59.434,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__z",
    width: 14.803,
    height: 14.803,
    x: 14.966,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__A",
    width: 14.803,
    height: 14.803,
    x: 23.377,
    y: 34.202,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__B",
    width: 14.803,
    height: 14.803,
    x: 23.377,
    y: 42.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__C",
    width: 14.803,
    height: 14.803,
    x: 23.377,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__D",
    width: 14.803,
    height: 14.803,
    x: 31.788,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__E",
    width: 14.803,
    height: 14.803,
    x: 40.199,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__F",
    width: 14.803,
    height: 14.803,
    x: 48.61,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__G",
    width: 14.803,
    height: 14.803,
    x: 57.021,
    y: 194.007,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__H",
    width: 14.803,
    height: 14.803,
    x: 166.361,
    y: 17.38,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__I",
    width: 14.803,
    height: 14.803,
    x: 174.772,
    y: 25.791,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__J",
    width: 14.803,
    height: 14.803,
    x: 174.772,
    y: 34.202,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__K",
    width: 14.803,
    height: 14.803,
    x: 183.183,
    y: 42.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__L",
    width: 14.803,
    height: 14.803,
    x: 183.183,
    y: 51.023,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__M",
    width: 14.803,
    height: 14.803,
    x: 191.594,
    y: 59.434,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__N",
    width: 14.803,
    height: 14.803,
    x: 191.594,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__O",
    width: 14.803,
    height: 14.803,
    x: 200.005,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__P",
    width: 14.803,
    height: 14.803,
    x: 208.415,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__Q",
    width: 14.803,
    height: 14.803,
    x: 216.826,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__R",
    width: 14.803,
    height: 14.803,
    x: 225.237,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__S",
    width: 14.803,
    height: 14.803,
    x: 334.578,
    y: 17.38,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__T",
    width: 14.803,
    height: 14.803,
    x: 342.989,
    y: 17.38,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__U",
    width: 14.803,
    height: 14.803,
    x: 342.989,
    y: 25.791,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__V",
    width: 14.803,
    height: 14.803,
    x: 351.4,
    y: 25.791,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__W",
    width: 14.803,
    height: 14.803,
    x: 359.81,
    y: 25.791,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__X",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 25.791,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__Y",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 34.202,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__Z",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 42.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__aa",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 67.845,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ab",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 76.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ac",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 84.666,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ad",
    width: 14.803,
    height: 14.803,
    x: 376.632,
    y: 84.666,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ae",
    width: 14.803,
    height: 14.803,
    x: 385.042,
    y: 84.666,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__af",
    width: 738.807,
    height: 253.923,
    x: -174.404,
    y: -13.866,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 7.128
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_9015_177815",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_9015_177815",
    stdDeviation: 5.867
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ah",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 59.434,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ai",
    width: 14.803,
    height: 14.803,
    x: -1.855,
    y: 151.953,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__aj",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 51.023,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__ak",
    width: 14.803,
    height: 14.803,
    x: 385.463,
    y: 185.597,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__al",
    width: 14.803,
    height: 14.803,
    x: 377.052,
    y: 185.597,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__am",
    width: 14.803,
    height: 14.803,
    x: 368.221,
    y: 185.597,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero-small_svg__an",
    width: 14.803,
    height: 14.803,
    x: 191.594,
    y: 51.023,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.009
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9015_177815",
    result: "effect2_dropShadow_9015_177815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_9015_177815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero-small_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 112.705 -303 0 195 113.095)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-small_svg__ag",
    x1: -160.147,
    x2: 546.521,
    y1: 169.448,
    y2: 71.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#111",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#111",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111",
    stopOpacity: 0
  })))));
};
export default SvgHeroSmall;